// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"380":"24a38b8c","435":"09322e55","724":"85d8f098","841":"ad5cca56"}[chunkId] + ".css";
};